import React from "react";
import Header from "../Components/Header";
import Breadcrumbs from "../Components/Breadcrumbs";
import PortfolioDetailsEcommerce from "../Components/PortfolioDetails_web_ecommers";
import Footer from "../Components/Footer";

const WebEcommerce = () => {
  return (
    <>
      <Header />
      <Breadcrumbs pageTitle="אתרי מכירות" />
      <PortfolioDetailsEcommerce />
      <Footer />
    </>
  );
};

export default WebEcommerce;
